export const caseInsensitiveFind = (arr: string[], str: string) => {
  return arr.find((item) => item.toLowerCase() === str.toLowerCase());
};
